function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useMemoizedFn } from 'ahooks'; // Hook 的类型定义
import { useCallback, useState } from 'react';

// Hook 的类型定义

function useControlledValue(_ref) {
  var controlledValue = _ref.value,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange;
  // 判断是否为受控模式
  var isControlled = controlledValue !== undefined;

  // 非受控模式下的内部状态
  var _useState = useState(defaultValue !== undefined ? defaultValue : controlledValue),
    _useState2 = _slicedToArray(_useState, 2),
    internalValue = _useState2[0],
    setInternalValue = _useState2[1];

  // 统一的值
  var value = isControlled ? controlledValue : internalValue;

  // 更新值的函数
  var setValue = useCallback(function (newValue) {
    if (isControlled) {
      // 受控模式下调用外部 onChange
      onChange === null || onChange === void 0 || onChange(newValue);
    } else {
      // 非受控模式下更新内部状态
      setInternalValue(newValue);
    }
  }, [isControlled, onChange]);
  return [value, useMemoizedFn(setValue), isControlled];
}
export default useControlledValue;